module.exports = {
	"version": "1.2080.9",
	"manifest": {
		"adminLoginButton": "1.2010.8",
		"animations": "1.2080.9",
		"audioCommon": "1.2080.9",
		"audioPlayer": "1.2080.9",
		"backToTopButton": "1.2010.8",
		"backgroundCommon": "1.2080.9",
		"balata": "1.2080.9",
		"balataCommon": "1.2080.9",
		"boxSlideShowSlide": "1.2080.9",
		"buttonCommon": "1.2080.9",
		"clipArt": "1.2010.8",
		"column": "1.2010.8",
		"comboBoxInput": "1.2080.9",
		"compDesignUtils": "1.2080.9",
		"compUtils": "1.2080.9",
		"components": "1.2080.9",
		"componentsPreviewLayer": "1.2080.9",
		"contactForm": "1.2080.9",
		"container": "1.2010.8",
		"containerCommon": "1.2010.8",
		"core": "1.2080.9",
		"coreUtils": "1.2080.9",
		"dataFixer": "1.2080.9",
		"datePicker": "1.2080.9",
		"dateUtils": "1.2010.8",
		"deadComponent": "1.2040.17",
		"displayer": "1.2080.9",
		"documentMedia": "1.2080.9",
		"documentServices": "1.2080.9",
		"editingRendererPlugins": "1.2010.8",
		"exitMobileModeButton": "1.2080.9",
		"facebookComments": "1.2080.9",
		"facebookLike": "1.2010.8",
		"facebookLikeBox": "1.2010.8",
		"fileUploader": "1.2080.9",
		"fonts": "1.2080.9",
		"fontsPrefetch": "1.2010.8",
		"footerContainer": "1.2010.8",
		"formCommon": "1.2080.9",
		"galleriesCommon": "1.2080.9",
		"googleMap": "1.2080.9",
		"groupContainer": "1.2040.17",
		"headerContainer": "1.2010.8",
		"htmlComponent": "1.2080.9",
		"image": "1.2080.9",
		"imageButton": "1.2040.17",
		"imageClientApi": "1.2010.8",
		"imageCommon": "1.2080.9",
		"layout": "1.2080.9",
		"linkBar": "1.2080.9",
		"loggingUtils": "1.2080.9",
		"loginButton": "1.2010.8",
		"matrixGallery": "1.2080.9",
		"mediaCommon": "1.2080.9",
		"mediaContainer": "1.2080.9",
		"mediaControlFullscreen": "1.2080.9",
		"mediaControlPlay": "1.2080.9",
		"mediaControlProgress": "1.2080.9",
		"mediaControlTime": "1.2080.9",
		"mediaControlVolume": "1.2080.9",
		"mediaControls": "1.2080.9",
		"mediaPlayer": "1.2080.9",
		"page": "1.2080.9",
		"paginatedGridGallery": "1.2080.9",
		"paypalButton": "1.2010.8",
		"pinItPinWidget": "1.2080.9",
		"pinterestFollow": "1.2080.9",
		"pinterestPinIt": "1.2010.8",
		"popupCloseTextButton": "1.2010.8",
		"popupContainer": "1.2080.9",
		"previewExtensionsCore": "1.2080.9",
		"qaAutomation": "1.2080.9",
		"radioButton": "1.2080.9",
		"radioGroup": "1.2080.9",
		"render": "1.2080.9",
		"rssButton": "1.2010.8",
		"santaProps": "1.2080.9",
		"screenWidthContainer": "1.2010.8",
		"server": "1.2010.8",
		"singleAudioPlayer": "1.2080.9",
		"siteBackground": "1.2080.9",
		"siteButton": "1.2080.9",
		"siteUtils": "1.2080.9",
		"skinExports": "1.2080.9",
		"skins": "1.2080.9",
		"slideShowGallery": "1.2080.9",
		"sliderGallery": "1.2080.9",
		"socialCommon": "1.2010.8",
		"soundCloudWidget": "1.2010.8",
		"spotifyFollow": "1.2010.8",
		"spotifyPlayer": "1.2010.8",
		"stripColumnsContainer": "1.2080.9",
		"stripContainer": "1.2080.9",
		"stripSlideShowSlide": "1.2080.9",
		"subscribeForm": "1.2080.9",
		"svgShape": "1.2080.9",
		"testUtils": "1.2080.9",
		"textArea": "1.2080.9",
		"textCommon": "1.2080.9",
		"textInput": "1.2010.8",
		"tinyMenu": "1.2010.8",
		"tpa": "1.2080.9",
		"translationsUtils": "1.2010.12",
		"tweenEngine": "1.2080.9",
		"twitterFeed": "1.2010.8",
		"utils": "1.2080.9",
		"video": "1.2080.9",
		"wPhoto": "1.2080.9",
		"wRichText": "1.2080.9",
		"wTwitterFollow": "1.2010.8",
		"warmup": "1.2080.9",
		"widgets": "1.2080.9",
		"wixCode": "1.2080.9",
		"wixCodeInit": "1.2080.9",
		"wixCodeSeo": "1.2080.9",
		"wixSites": "1.2010.8",
		"wixSkinOnly": "1.2010.8",
		"wixUrlParser": "1.2080.9",
		"wixappsBuilder": "1.2080.9",
		"wixappsClassics": "1.2080.9",
		"wixappsCore": "1.2080.9",
		"zoomedImage": "1.2010.8"
	},
	"versions": {
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"balataCommon",
		"boxSlideShowSlide",
		"buttonCommon",
		"clipArt",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"displayer",
		"documentMedia",
		"documentServices",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"fileUploader",
		"fonts",
		"fontsPrefetch",
		"footerContainer",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"groupContainer",
		"headerContainer",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"matrixGallery",
		"mediaCommon",
		"mediaContainer",
		"mediaControlFullscreen",
		"mediaControlPlay",
		"mediaControlProgress",
		"mediaControlTime",
		"mediaControlVolume",
		"mediaControls",
		"mediaPlayer",
		"page",
		"paginatedGridGallery",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"radioButton",
		"radioGroup",
		"render",
		"rssButton",
		"santaProps",
		"screenWidthContainer",
		"server",
		"singleAudioPlayer",
		"siteBackground",
		"siteButton",
		"siteUtils",
		"skinExports",
		"skins",
		"slideShowGallery",
		"sliderGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgShape",
		"testUtils",
		"textArea",
		"textCommon",
		"textInput",
		"tinyMenu",
		"tpa",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"video",
		"wPhoto",
		"wRichText",
		"wTwitterFollow",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixSkinOnly",
		"wixUrlParser",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 24
// module chunks = 0